<h1 id="corporate-income-tax">Impôt corporatif</h1>

<div class="card">
  <div class="card-body">
    <h2>Informations sur l'entreprise</h2>
    <div class="d-flex gap-4">
      <magieno-datepicker
              [advancedFormControl]="this.corporateIncomeTaxOptionsForm.formElements.fiscalYearStart | asAdvancedFormControl">
        <i class="fas fa-calendar" calendarIcon></i>
      </magieno-datepicker>

      <magieno-datepicker
              [advancedFormControl]="this.corporateIncomeTaxOptionsForm.formElements.fiscalYearEnd | asAdvancedFormControl">
        <i class="fas fa-calendar" calendarIcon></i>
      </magieno-datepicker>
    </div>

    <div class="d-flex gap-4 mt-2">
      <magieno-select
              [advancedFormControl]="this.corporateIncomeTaxOptionsForm.formElements.companyType | asAdvancedFormControl"></magieno-select>
    </div>
    <div class="d-flex gap-4 mt-2">
      <magieno-input-rate-field
              [advancedFormControl]="this.corporateIncomeTaxOptionsForm.formElements.lossTaxRate | asAdvancedFormControl"
      ></magieno-input-rate-field>
    </div>

  </div>
</div>

<div class="card">
  <div class="card-body">
    <h2 id="information-sur-la-composition-du-revenu-net-fiscal"> Informations sur la composition du revenu net
      fiscal</h2>

    <div class="d-flex gap-4 mt-3">
      <magieno-input-money-field
              [advancedFormControl]="this.corporateIncomeTaxOptionsForm.formElements.businessIncome | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>

      <magieno-input-money-field
              [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.capitalGain | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>

      <magieno-input-money-field
              [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.capitalLoss | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>

    </div>

    <h2 class="mt-4">Autres revenus</h2>

    <div class="d-flex gap-4 mt-3">
      <magieno-input-money-field
              [advancedFormControl]="corporateIncomeTaxOptionsForm.formElements.interestIncome | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>

      <magieno-input-money-field
              [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.nonEligibleDividendNonConnected | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>

      <magieno-input-money-field
              [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.eligibleDividendNonConnected | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>

    </div>
  </div>
</div>


<div class="mt-5">

  <app-salary-dividend-corporate-tax-connected-corporations-form [connectedCorporations]="this.connectedCorporations"
                                                                 [form]="form"></app-salary-dividend-corporate-tax-connected-corporations-form>

</div>

<h2 id="report-de-soldes-fiscaux">Report de soldes fiscaux</h2>

<div class="mt-5 card">
  <div class="card-body">
    <h3 id="report-de-pertes">Report de pertes</h3>

    <div class="d-flex">
      <magieno-input-money-field
              [advancedFormControl]="this.corporateIncomeTaxOptionsForm.formElements.nonCapitalLossBalance | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>

      <magieno-input-money-field
              [advancedFormControl]="this.corporateIncomeTaxOptionsForm.formElements.capitalLossBalance | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
    </div>
  </div>
</div>






@if (this.corporateIncomeTaxOptionsForm.value.companyType === CompanyType.ccpcAllYear && this.form.value.isEligibleDividendMaximized) {
  <h2 class="mt-4" id="compte-de-revenu-a-taux-general">Compte de revenu à taux général</h2>
  <div class="mt-5 card">
    <div class="card-body d-flex">
      <magieno-input-money-field
              [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.gRIPBalance | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
      <magieno-input-money-field
              [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.eligibleDividendPaidLastYear | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
    </div>
  </div>
}

@if (this.corporateIncomeTaxOptionsForm.value.companyType !== CompanyType.ccpcAllYear) {
  <h2 class="mt-4" id="compte-de-revenu-a-taux-general">Compte de revenu à taux général</h2>
  <div class="mt-5 card">
    <div class="card-body d-flex">
      <magieno-input-money-field
              [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.lRIPBalance | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
    </div>
  </div>
}

@if (corporateIncomeTaxFederalForm.value.isPartIVTaxUsed === true) {
  <h2 class="mt-4" id="impot-en-main-remboursable">Impôt en main remboursable</h2>
  <div class="mt-5 card">
    <div class="card-body">
      <div class="d-flex">
        <magieno-input-money-field
                [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.previousIMRTDND | asAdvancedFormControl"
                [currency]="this.currency"
                [locale]="this.locale"></magieno-input-money-field>
        <magieno-input-money-field
                [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.previousRTDND | asAdvancedFormControl"
                [currency]="this.currency"
                [locale]="this.locale"></magieno-input-money-field>
      </div>
      <div class="d-flex mt-3">
        <magieno-input-money-field
                [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.previousIMRTDD | asAdvancedFormControl"
                [currency]="this.currency"
                [locale]="this.locale"></magieno-input-money-field>
        <magieno-input-money-field
                [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.previousRTDD | asAdvancedFormControl"
                [currency]="this.currency"
                [locale]="this.locale"></magieno-input-money-field>
      </div>
    </div>
  </div>
}

<h2 id="information-sur-la-DPE">Informations sur la déduction pour petite entreprise (DPE)</h2>

<div class="card">
  <div class="card-body">
    @if (this.corporateIncomeTaxOptionsForm.value.companyType === CompanyType.ccpcAllYear) {
      <div class="d-flex gap-4">
        <magieno-input-money-field
                class="flex-fill"
                [advancedFormControl]="this.corporateIncomeTaxOptionsForm.formElements.assignedBusinessLimit | asAdvancedFormControl"
                [currency]="this.currency"
                [locale]="this.locale"></magieno-input-money-field>
      </div>
      <div class="d-flex gap-4 mt-3">
        <magieno-input-money-field
                class="flex-fill"
                [advancedFormControl]="this.corporateIncomeTaxOptionsForm.formElements.totalTaxableCapital | asAdvancedFormControl"
                [currency]="this.currency"
                [locale]="this.locale"></magieno-input-money-field>
      </div>
      <div class="d-flex gap-4 mt-3">
        <magieno-input-money-field
                class="flex-fill"
                [advancedFormControl]="this.corporateIncomeTaxOptionsForm.formElements.adjustedInvestmentIncome | asAdvancedFormControl"
                [currency]="this.currency"
                [locale]="this.locale"></magieno-input-money-field>
      </div>
    }

    <div class="d-flex mt-3">
      <magieno-boolean-select
              [advancedFormControl]="corporateIncomeTaxQuebecForm.formElements.isManufacturingSectorActivity | asAdvancedFormControl"></magieno-boolean-select>
    </div>

    @if (corporateIncomeTaxQuebecForm.value.isManufacturingSectorActivity === false) {
      <div class="ms-4 mt-4 d-flex">
        <magieno-input-number-field
                [advancedFormControl]="corporateIncomeTaxQuebecForm.formElements.currentPaidHours | asAdvancedFormControl"></magieno-input-number-field>
        <magieno-input-number-field
                [advancedFormControl]="corporateIncomeTaxQuebecForm.formElements.previousPaidHours | asAdvancedFormControl"></magieno-input-number-field>
      </div>
    }
  </div>
</div>

<h2 id="informations-sur-les-dividendes-versees">Informations sur les dividendes versés</h2>

<div class="card">
  <div class="card-body d-flex gap-3">

    <magieno-input-money-field
            [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.nonEligibleDividendPaid | asAdvancedFormControl"
            [currency]="this.currency"
            [locale]="this.locale"></magieno-input-money-field>

    <magieno-input-money-field
            [advancedFormControl]="corporateIncomeTaxFederalForm.formElements.eligibleDividendPaid | asAdvancedFormControl"
            [currency]="this.currency"
            [locale]="this.locale"></magieno-input-money-field>
  </div>
</div> <!-- / .row -->

<h2 id="cotisations-salariales">Cotisations salariales (employé et employeur)</h2>

<div class="card">
  <div class="card-body">
    <div class="d-flex gap-4">
      <magieno-boolean-select
              class="flex-fill"
              [advancedFormControl]="this.form.formElements.isShareHolderSubjectToEI | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              class="flex-fill"
              [advancedFormControl]="this.salaryContributionsForm.formElements.shouldCNTBeCalculated | asAdvancedFormControl"></magieno-boolean-select>
    </div>
    <div class="mt-4">
      <magieno-boolean-select
              [advancedFormControl]="this.salaryContributionsForm.formElements.shouldCNESSTBeCalculated | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.salaryContributionsForm.value.shouldCNESSTBeCalculated) {
        <div class="ms-4 mt-4">
          <magieno-input-number-field
                  [advancedFormControl]="this.salaryContributionsForm.formElements.recurringPaymentRate | asAdvancedFormControl"
                  [locale]="this.locale"
                  max="100"
                  min="0"></magieno-input-number-field>
        </div>
      }
    </div>
    <div class="mt-4">

      <magieno-boolean-select
              [advancedFormControl]="this.salaryContributionsForm.formElements.shouldFSSBeCalculated | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.salaryContributionsForm.value.shouldFSSBeCalculated === true) {
        <div class="ms-4 mt-4">
          <div class="d-flex gap-4">
            <magieno-input-money-field
                    [advancedFormControl]="this.salaryContributionsForm.formElements.totalPayroll | asAdvancedFormControl"
                    [currency]="this.currency"
                    [locale]="this.locale"></magieno-input-money-field>
            <magieno-input-money-field
                    [advancedFormControl]="this.salaryContributionsForm.formElements.totalPayrollForPrimarySector | asAdvancedFormControl"
                    [currency]="this.currency"
                    [locale]="this.locale"></magieno-input-money-field>
          </div>

          <div class="mt-4">
            <magieno-boolean-select
                    [advancedFormControl]="this.salaryContributionsForm.formElements.isEmployerFromPublicSector | asAdvancedFormControl"></magieno-boolean-select>
          </div>
        </div>
      }
    </div>
  </div>
</div>


